export default __webpack_public_path__ + "static/media/Artwork.4eb20e6d.svg";